import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { createPortal } from "react-dom";
import moment from "moment";
import "moment/locale/es";
import "moment/locale/ja";
import { getMomentLocale } from "../utils/appLocale";
import { useTranslation } from "react-i18next";
import iconTrash from "../assets/pepper-icons/rightbar/iconTrash.svg";
//import pepperIcon3 from "../assets/pepper-icons/sidebar/Pepper3IconSinfondo.svg";
import pepperIcon3 from "../assets/svg/Pepper/Logo_Pepper_2022.svg";
import { useSelector, useDispatch } from "react-redux";
import { useBlockedFeatures } from "src/hooks/useBlockedFeatures";
import { useModulePermissions } from "src/hooks/useModulePermissions";
import { PaymentSuccessful } from "src/graphql/company";
import {
  Button,
  Dropdown,
  Icon,
  Segment,
  Popup,
  Header as SemanticHeader,
  Image,
  Label,
  Input,
  Placeholder,
} from "semantic-ui-react";
import CompanyListComponent from "./CompanyListComponent";
import { SubcribeWS, consumeBotlogToastOnce } from "../graphql/botsWs";
import { rutWithDash } from "../utils/formatter";
import {
  importMonedas,
  setCurrency,
  setSidebarResponsive,
} from "../redux/actions/ui";
import {
  importNotifications,
  importUpdateNotifications,
  updateNotifications,
} from "../redux/actions/notifications";
import { startLogout } from "../redux/actions/auth";
import {
  CHeader,
  CToggler,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from "@coreui/react";
import ConciliationRatioCircle from "src/components/header/ConciliationRatioCircle";
import {
  importSelectedCompany,
  importLoadingState,
  importReportGroupCompanyIds,
  importExcludeIntercompanyReports,
} from "../redux/actions/companyList";
import { importAlertState } from "../redux/actions/alert";
import { setUpdateDocuments } from "../redux/actions/documentostributarios";
import {
  importUpdateNominaInProcessNeeded,
  importUpdateNominaProccesedNeeded,
  importUpdateProvidersData,
} from "../redux/actions/proveedores";
import { importUpdateTransactions } from "../redux/actions/conciliacion";
import {
  importUpdateBalanceNeeded,
  importUpdateCashFlow,
} from "../redux/actions/flujocaja";
import { posiblePasswords } from "src/utils/passwordAccepted";

import "./Header.scss";
import { Plans } from "src/utils/plans";
import { importUpdateDashboardNeeded, updateConcilieantionRatio } from "src/redux/actions/dashboard";
import { importUpdatePasswordNeeded } from "src/redux/actions/conexiones";
import { importDataConexiones } from "src/redux/actions/conexiones";
import { GetPasswordsByCompany } from "src/graphql/conexiones";
import bankLogo from "src/assets/svg/svg_banks";
import platformLogo from "src/assets/svg/svg_platforms";
import UserIcon from "src/assets/icons/Avatar_standard.svg";
import aiIcon from "src/assets/icons/ai-icon.svg";
import logOutWhiteIcon from "src/assets/svg/svg_icons/log_out_white.svg";
import bellIcon from "src/assets/svg/svg_icons/bell.svg";
import AiSideChat from "src/components/ai/AiSideChat";
import { useContext } from "react";
import { CompanyContext, UserContext } from "src/context";
import {
  hasAnyAccountingModuleAccess,
  showAccounting,
} from "src/utils/accounting";
import {
  AppNotificationsSuscription,
  BELL_HIDDEN_BOTLOG_BOTNAMES,
  formatAppNotifications,
  GetAppNotificationsList,
  MarkNotificationAsReaded,
  MarkAllNotificationAsRead,
} from "src/graphql/appNotifications";
import {
  isReconciliationBotlog,
  logReconciliationTechnicalError,
} from "../utils/reconciliationFriendlyMessages";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { importOpenSidebar } from "src/redux/actions/openSidebar";
import { openSidebarStateFromRedirectUrl } from "src/utils/notificationOpenSidebar";
import { GlobalSearch } from "./GlobalSearch/GlobalSearch";
import { parseCommentMentionParts } from "src/utils/commentMentions";
import FilterTabs from "../components/FilterTabs/FilterTabs";
import CreateObligationModal from "../components/configuracion/createObligationModal/createObligationModal";
import CreateJournalEntryModal from "../components/general/js/forms/reconcile/contabilidad/CreateJournalEntryModal";
import {
  GetMyFavoriteRoutes,
  AddFavoriteRoute,
  RemoveFavoriteRoute,
} from "src/graphql/users";
import { useProfileAvatar } from "src/hooks/useProfileAvatar";
import { useCanUploadProfileImage } from "src/hooks/useCanUploadProfileImage";
import FavoriteRouteModal from "src/components/header/FavoriteRouteModal";
import ProfileImageUploadModal from "src/components/header/ProfileImageUploadModal";
import HeaderLanguageSelector from "src/components/header/HeaderLanguageSelector";
import AiOpportunitiesDropdown from "src/components/header/AiOpportunitiesDropdown";
import AccountSuggestionsSidePanel from "src/components/header/AccountSuggestionsSidePanel";
import {
  ACCOUNT_SUGGESTIONS_PANEL_EVENT,
  isAccountSuggestionsRedirectUrl,
  parseSuggestionsDirectionFromUrl,
} from "src/utils/accountSuggestionsPanel";
import { TriggerPascaleBot } from "src/graphql/pascale";
import { ExecutePascaleAutomations, ReconciliationProgressSubscription } from "src/graphql/reconcileRules";
import PascaleRunProgress from "src/components/pascale/PascaleRunProgress";

const FAVORITE_ROUTE_LABEL_DISPLAY_MAX = 28;
const RUN_AUTOMATIONS_LOCK_KEY = "smartcfo:runAutomationsLock";
const RUN_AUTOMATIONS_LOCK_MS = 300_000;

const isPlaceholderProfileName = (value) => {
  if (value == null) return true;
  const trimmed = String(value).trim();
  return trimmed === "" || trimmed === "-";
};

const readRunAutomationsLock = () => {
  try {
    const raw = localStorage.getItem(RUN_AUTOMATIONS_LOCK_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const isRunAutomationsLockActive = (companyId) => {
  if (!companyId) return false;
  const lock = readRunAutomationsLock();
  if (!lock || String(lock.companyId) !== String(companyId)) return false;
  return Date.now() < lock.until;
};

const setRunAutomationsLock = (companyId) => {
  localStorage.setItem(
    RUN_AUTOMATIONS_LOCK_KEY,
    JSON.stringify({ companyId: String(companyId), until: Date.now() + RUN_AUTOMATIONS_LOCK_MS })
  );
};

const clearRunAutomationsLock = () => {
  localStorage.removeItem(RUN_AUTOMATIONS_LOCK_KEY);
};

const truncateFavoriteRouteLabel = (label, maxLength = FAVORITE_ROUTE_LABEL_DISPLAY_MAX) => {
  const text = String(label || "").trim();
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength)}…`;
};

/** Alinea URLs de notificaciones con el panel interno (no RightSidebar legacy). */
const normalizeNotificationRedirectUrl = (url) => {
  if (!url || typeof url !== "string") return url;
  const qIndex = url.indexOf("?");
  const path = qIndex >= 0 ? url.slice(0, qIndex) : url;
  const params = new URLSearchParams(qIndex >= 0 ? url.slice(qIndex + 1) : "");

  if (path.includes("conciliacion")) {
    const legacyId = params.get("id");
    if (legacyId && !params.get("transactionId")) {
      params.set("transactionId", legacyId);
      params.delete("id");
    }
    if (params.get("transactionId") && params.get("isComment") === "true" && !params.has("isUnique")) {
      params.set("isUnique", "true");
    }
  }
  if (path.includes("documentos_tributarios")) {
    const legacyId = params.get("id");
    if (legacyId && !params.get("documentId")) {
      params.set("documentId", legacyId);
      params.delete("id");
    }
    if (params.get("documentId") && params.get("isComment") === "true" && !params.has("isUnique")) {
      params.set("isUnique", "true");
    }
  }
  if (
    path.includes("cobranza") &&
    !params.get("tab") &&
    (params.get("clientKey") || params.get("documentId"))
  ) {
    params.set("tab", "gestion");
  }

  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
};

const GROUPED_COMPANY_DATA_PATHS = [
  "/dashboard",
  "/reportes_ventas",
  "/reportes_compras",
  "/reportes_cobranza",
  "/reportes_proveedores",
  "/flujo_caja",
  "/balance_8_columnas",
  "/balance_clasificado",
  "/estado_de_resultados_contable",
  "/libro_mayor",
  "/libro_diario",
];

const isGroupedCompanyDataPath = (path = "") =>
  GROUPED_COMPANY_DATA_PATHS.some((groupedPath) => path.startsWith(groupedPath));

const getCompanyGroupScopeKey = (company) => {
  const groupId = company?.group?.groupId ? String(company.group.groupId).trim() : "";
  if (groupId) return `id:${groupId}`;
  const groupName = company?.group?.groupName
    ? String(company.group.groupName).trim().toLowerCase()
    : "";
  if (groupName) return `name:${groupName}`;
  return null;
};

/** Misma regla que BE requireSameGroup / getCompanyGroupScopeKey */
const getSameGroupCompanies = (companyList, selectedCompanyData) => {
  const list = Array.isArray(companyList) ? companyList : [];
  if (!selectedCompanyData?.id) return [];

  const selectedKey = getCompanyGroupScopeKey(selectedCompanyData);
  if (!selectedKey) {
    return list.filter((company) => String(company.id) === String(selectedCompanyData.id));
  }

  return list.filter((company) => getCompanyGroupScopeKey(company) === selectedKey);
};

function PascaleProgressListener({ companyId, onProgress }) {
  ReconciliationProgressSubscription(companyId, onProgress);
  return null;
}

const Header = ({ location, isFixed, isMobile }) => {
  const { t, i18n } = useTranslation("header");
  const dispatch = useDispatch();
  const { hasRouteAccess, hasModuleAccess, canCreateAsiento } = useModulePermissions();
  const { isFeatureBlocked } = useBlockedFeatures();
  const isAsientoBlocked = isFeatureBlocked('asiento');
  const puedeCrearAsiento = canCreateAsiento();
  const isCrearObligacionBlocked = isFeatureBlocked('crear_obligacion');
  const canUsePascaleChat = !isFeatureBlocked('pascale_chat');
  const { dataConexiones, allConnections } = useSelector(
    (state) => state.conexiones
  );
  const [openNotification, setOpenNotification] = useState(false);

  const [open, setOpen] = useState(false);
  const [openPlusModal, setOpenPlusModal] = useState(false);
  const [openJournalEntryModal, setOpenJournalEntryModal] = useState(false);
  const previousPathRef = useRef(location?.pathname || "");
  const previousSelectedCompanyIdRef = useRef(null);
  const [profileUploadOpen, setProfileUploadOpen] = useState(false);
  const canUploadProfileImage = useCanUploadProfileImage();
  const { email, name, surname, uid, ...rest } = useSelector(
    (state) => state.auth
  );
  const { reportGroupCompanyIds, excludeIntercompanyReports } = useSelector(
    (state) => state.companyList
  );
  const { sidebarShow, dropdownCurrency, currency } = useSelector(
    (state) => state.ui
  );
  const { notification } = useSelector((state) => state.notifications);

  const { companyList, selectedCompany } = useContext(CompanyContext);
  const { roles } = useContext(UserContext);
  const hasAccountingAccess = hasAnyAccountingModuleAccess(hasModuleAccess);
  const currentUser = useSelector((state) => state.auth);;

  const companyId = selectedCompany?.id;
  const res = SubcribeWS(companyId);

  // Mismo User.id que JWT (sub / user.id) y recipients en Mongo — no usar allUsersByCompany.
  const notificationsUserId = uid;
  const hasSession = (() => {
    if (typeof window === "undefined") return false;
    if (localStorage.getItem("token")) return true;
    try {
      return Boolean(JSON.parse(localStorage.getItem("user") || "null")?.uid);
    } catch {
      return false;
    }
  })();
  const notificationsSubscriptionPaused = !uid || !hasSession;

  const resNotifications = AppNotificationsSuscription(notificationsUserId, {
    pause: notificationsSubscriptionPaused,
  });
  const {
    data: appNotificationsData,
    fetching: appNotificationsFetching,
    error: appNotificationsError,
    reexecuteQuery: appNotificationsReexecuteQuery,
  } = GetAppNotificationsList(notificationsUserId, null, {
    pause: !notificationsUserId || !open,
    requestPolicy: "network-only",
  });
  const [unreadedNotificationsQuantity, setUnreadedNotificationsQuantity] = useState(0);

  const [notifications, setNotifications] = useState([]);
  const pendingNotificationRedirectRef = useRef(null);
  const getNotificationRecipients = (item) =>
    item?.notification?.recipients || item?.recipients || [];

  const applyLiveNotifications = useCallback((rawList) => {
    if (!Array.isArray(rawList)) return;
    if (rawList.length === 0) {
      setNotifications([]);
      return;
    }

    const incoming = formatAppNotifications(rawList);
    incoming.sort((a, b) => {
      const aTime =
        Date.parse(a?.notification?.createdAt || a?.notification?.created_at || 0) || 0;
      const bTime =
        Date.parse(b?.notification?.createdAt || b?.notification?.created_at || 0) || 0;
      return bTime - aTime;
    });
    setNotifications(incoming);
  }, []);

  const [activeTab, setActiveTab] = useState('new'); // 'new' or 'read'
  const [aiChatOpen, setAiChatOpen] = useState(false);
  const [accountSuggestionsPanelOpen, setAccountSuggestionsPanelOpen] = useState(false);
  const [accountSuggestionsPanelDirection, setAccountSuggestionsPanelDirection] = useState(null);
  const [aiPulseActive, setAiPulseActive] = useState(false);
  const [favoriteRouteModalOpen, setFavoriteRouteModalOpen] = useState(false);
  const [savingFavoriteRoute, setSavingFavoriteRoute] = useState(false);
  const [removingFavoriteRouteId, setRemovingFavoriteRouteId] = useState(null);
  const [runAutomationsLoading, setRunAutomationsLoading] = useState(false);
  const [pascaleOverlay, setPascaleOverlay] = useState(null);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const languageSubmenuOpenRef = useRef(false);
  const runAutomationsReleaseTimerRef = useRef(null);

  const { executeMutation: triggerPascaleBot } = TriggerPascaleBot();
  const { executeMutation: executePascaleAutomations } = ExecutePascaleAutomations();

  // El cliente no ve el estado de cada conexión en el header.
  const hideConnectionStatusList = (roles || []).includes("USER_SMARTCFO");

  // Ejecutar Pascale: solo equipo interno (ADMIN/COLABORADOR/SUPER_COLABORADOR).
  // USER_SMARTCFO no puede verlo ni ejecutarlo aunque tenga contabilidad/asientos.
  const isInternalStaffForPascale = useMemo(
    () =>
      (roles || []).some((r) =>
        ["ADMIN", "COLABORADOR", "SUPER_COLABORADOR"].includes(r)
      ),
    [roles]
  );

  const canRunPascaleAccounting = useMemo(
    () =>
      isInternalStaffForPascale &&
      showAccounting(roles, selectedCompany) &&
      Boolean(selectedCompany?.isPascaleActive?.active) &&
      !isAsientoBlocked &&
      puedeCrearAsiento,
    [
      isInternalStaffForPascale,
      roles,
      selectedCompany,
      isAsientoBlocked,
      puedeCrearAsiento,
    ]
  );

  const clearRunAutomationsReleaseTimer = useCallback(() => {
    if (runAutomationsReleaseTimerRef.current) {
      clearTimeout(runAutomationsReleaseTimerRef.current);
      runAutomationsReleaseTimerRef.current = null;
    }
  }, []);

  const releaseRunAutomationsLock = useCallback(() => {
    clearRunAutomationsReleaseTimer();
    clearRunAutomationsLock();
    setRunAutomationsLoading(false);
  }, [clearRunAutomationsReleaseTimer]);

  const scheduleRunAutomationsRelease = useCallback(
    (activeCompanyId, remainingMs) => {
      clearRunAutomationsReleaseTimer();
      runAutomationsReleaseTimerRef.current = setTimeout(() => {
        const lock = readRunAutomationsLock();
        if (
          lock &&
          String(lock.companyId) === String(activeCompanyId) &&
          Date.now() >= lock.until
        ) {
          clearRunAutomationsLock();
        }
        setRunAutomationsLoading(false);
        runAutomationsReleaseTimerRef.current = null;
      }, remainingMs);
    },
    [clearRunAutomationsReleaseTimer]
  );

  const syncRunAutomationsLockFromStorage = useCallback(() => {
    const activeCompanyId = selectedCompany?.id || selectedCompany?._id;
    if (!activeCompanyId) {
      setRunAutomationsLoading(false);
      return;
    }

    const lock = readRunAutomationsLock();
    if (!lock || String(lock.companyId) !== String(activeCompanyId)) {
      setRunAutomationsLoading(false);
      return;
    }

    const remaining = lock.until - Date.now();
    if (remaining <= 0) {
      clearRunAutomationsLock();
      setRunAutomationsLoading(false);
      return;
    }

    setRunAutomationsLoading(true);
    scheduleRunAutomationsRelease(activeCompanyId, remaining);
  }, [selectedCompany?.id, selectedCompany?._id, scheduleRunAutomationsRelease]);

  useEffect(() => {
    syncRunAutomationsLockFromStorage();
    return () => clearRunAutomationsReleaseTimer();
  }, [syncRunAutomationsLockFromStorage, clearRunAutomationsReleaseTimer]);

  useEffect(() => {
    const onStorage = (event) => {
      if (event.key === RUN_AUTOMATIONS_LOCK_KEY) {
        syncRunAutomationsLockFromStorage();
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [syncRunAutomationsLockFromStorage]);

  useEffect(() => {
    if (!canUsePascaleChat && aiChatOpen) setAiChatOpen(false);
  }, [canUsePascaleChat, aiChatOpen]);

  const openAccountSuggestionsPanel = useCallback((direction = null) => {
    if (!hasAccountingAccess) return;
    setAiChatOpen(false);
    setAccountSuggestionsPanelDirection(direction);
    setAccountSuggestionsPanelOpen(true);
  }, [hasAccountingAccess]);

  const openAiChat = useCallback(() => {
    setAccountSuggestionsPanelOpen(false);
    setAiChatOpen(true);
  }, []);

  useEffect(() => {
    const onOpenPanel = (event) => {
      const direction = event?.detail?.direction ?? null;
      openAccountSuggestionsPanel(direction);
    };
    window.addEventListener(ACCOUNT_SUGGESTIONS_PANEL_EVENT, onOpenPanel);
    return () => window.removeEventListener(ACCOUNT_SUGGESTIONS_PANEL_EVENT, onOpenPanel);
  }, [openAccountSuggestionsPanel]);

  useEffect(() => {
    if (!hasAccountingAccess || !location?.hash) return;
    const hash = String(location.hash).replace(/^#/, '');
    if (!hash.startsWith('sugerencias-cuentas')) return;
    const direction = parseSuggestionsDirectionFromUrl(hash);
    openAccountSuggestionsPanel(direction);
    if (window.history?.replaceState) {
      window.history.replaceState(null, '', `${location.pathname}${location.search}`);
    }
  }, [hasAccountingAccess, location?.hash, location?.pathname, location?.search, openAccountSuggestionsPanel]);

  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);

  const isGroupedReportModule = useMemo(() => {
    return isGroupedCompanyDataPath(location?.pathname || "");
  }, [location?.pathname]);

  const selectedCompanyData = useMemo(() => {
    const list = Array.isArray(companyList) ? companyList : [];
    if (!selectedCompany?.id) return selectedCompany;
    return list.find((company) => company.id === selectedCompany.id) || selectedCompany;
  }, [companyList, selectedCompany]);

  const sameGroupCompanies = useMemo(
    () => getSameGroupCompanies(companyList, selectedCompanyData),
    [companyList, selectedCompanyData]
  );

  const reportGroupCompanyOptions = useMemo(
    () =>
      sameGroupCompanies.map((company) => ({
        value: company.id,
        label: company.alias || company.name,
      })),
    [sameGroupCompanies]
  );

  const shouldShowReportGroupSelector =
    isGroupedReportModule && sameGroupCompanies.length > 1;

  const normalizedReportGroupCompanyIds = useMemo(
    () => (Array.isArray(reportGroupCompanyIds) ? [...new Set(reportGroupCompanyIds.map(String))] : []),
    [reportGroupCompanyIds]
  );

  const isViewingCombinedCompanyData =
    isGroupedReportModule && normalizedReportGroupCompanyIds.length > 1;

  const combinedCompanyNames = useMemo(() => {
    const selectedIds = new Set(normalizedReportGroupCompanyIds);
    return sameGroupCompanies
      .filter((company) => selectedIds.has(String(company.id)))
      .map((company) => company.alias || company.name)
      .filter(Boolean);
  }, [normalizedReportGroupCompanyIds, sameGroupCompanies]);

  const combinedDataTooltip = combinedCompanyNames.length > 0
    ? `Estás viendo datos combinados de: ${combinedCompanyNames.join(", ")}.`
    : `Estás viendo datos combinados de ${normalizedReportGroupCompanyIds.length} empresas.`;

  const areSameIdArrays = (a = [], b = []) => {
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    const normalizedA = [...a].map(String).sort();
    const normalizedB = [...b].map(String).sort();
    return normalizedA.every((id, index) => id === normalizedB[index]);
  };

  // Sanitiza IDs inválidos / inicializa default. No vaciar la selección mientras
  // el grupo aún no está disponible (evita borrar Combinados en refrescos).
  useEffect(() => {
    const allowedIds = new Set(sameGroupCompanies.map((company) => String(company.id)));
    const selectedCompanyId = selectedCompanyData?.id;
    const selectedCompanyDefault =
      selectedCompanyId && allowedIds.has(String(selectedCompanyId))
        ? [selectedCompanyId]
        : [];

    if (sameGroupCompanies.length === 0) {
      return;
    }

    const currentIds = Array.isArray(reportGroupCompanyIds)
      ? reportGroupCompanyIds.filter((id) => allowedIds.has(String(id)))
      : [];

    const hasInvalidIds = (reportGroupCompanyIds || []).length !== currentIds.length;
    const mustResetToDefault =
      currentIds.length === 0 && selectedCompanyDefault.length > 0;

    if (!hasInvalidIds && !mustResetToDefault) {
      return;
    }

    if (mustResetToDefault) {
      if (!areSameIdArrays(reportGroupCompanyIds || [], selectedCompanyDefault)) {
        dispatch(importReportGroupCompanyIds(selectedCompanyDefault));
      }
      return;
    }

    if (!areSameIdArrays(reportGroupCompanyIds || [], currentIds)) {
      dispatch(importReportGroupCompanyIds(currentIds));
    }
  }, [
    dispatch,
    sameGroupCompanies,
    reportGroupCompanyIds,
    selectedCompanyData?.id,
  ]);

  // Solo resetear Combinados al cambiar de empresa, no en mount/hidratación
  // (ese reset hacía que los checkboxes “no pegaran” de forma intermitente).
  useEffect(() => {
    const selectedCompanyId = selectedCompanyData?.id
      ? String(selectedCompanyData.id)
      : null;
    if (!selectedCompanyId) return;

    const previousId = previousSelectedCompanyIdRef.current;
    previousSelectedCompanyIdRef.current = selectedCompanyId;

    if (!previousId || previousId === selectedCompanyId) {
      return;
    }

    dispatch(importReportGroupCompanyIds([selectedCompanyId]));
  }, [dispatch, selectedCompanyData?.id]);

  useEffect(() => {
    const previousPath = previousPathRef.current;
    const currentPath = location?.pathname || "";
    const hasChangedPath = previousPath !== currentPath;
    const isLeavingGroupedCompanyData =
      isGroupedCompanyDataPath(previousPath) && !isGroupedCompanyDataPath(currentPath);

    if (hasChangedPath && isLeavingGroupedCompanyData && normalizedReportGroupCompanyIds.length > 1) {
      dispatch(
        importAlertState({
          concept: "Datos de empresa individual",
          content: `Este módulo usa solamente la data de ${selectedCompanyData?.alias || selectedCompanyData?.name || "la empresa seleccionada"}, no la combinación de empresas.`,
          state: "warning",
          duration: 6,
        })
      );
    }

    previousPathRef.current = currentPath;
  }, [
    dispatch,
    location?.pathname,
    normalizedReportGroupCompanyIds.length,
    selectedCompanyData?.alias,
    selectedCompanyData?.name,
  ]);

  const handleReportGroupCompaniesChange = (values) => {
    const selectedValues = Array.isArray(values) ? values : [];
    const fallbackValues = selectedCompanyData?.id ? [selectedCompanyData.id] : [];
    dispatch(
      importReportGroupCompanyIds(
        selectedValues.length > 0 ? selectedValues : fallbackValues
      )
    );
  };

  const handleLogout = (event) => {
    event?.preventDefault?.();
    setUserMenuOpen(false);
    dispatch(startLogout());
    history.replace("/signin");
  };

  const handleLanguageSubmenuOpenChange = useCallback((open) => {
    languageSubmenuOpenRef.current = open;
  }, []);

  useEffect(() => {
    if (!userMenuOpen) return undefined;

    const handleOutsideUserMenu = (event) => {
      const target = event.target;
      const menuEl = document.querySelector(".headerUserMenu");
      const triggerEl = document.querySelector(".header-dropdown-avatar");
      const languagePanelEl = document.querySelector(".headerLanguageMenuPanel--portal");

      if (
        menuEl?.contains(target) ||
        triggerEl?.contains(target) ||
        languagePanelEl?.contains(target)
      ) {
        return;
      }

      languageSubmenuOpenRef.current = false;
      setUserMenuOpen(false);
    };

    document.addEventListener("mousedown", handleOutsideUserMenu);
    return () => document.removeEventListener("mousedown", handleOutsideUserMenu);
  }, [userMenuOpen]);

  const handleGoToProfile = () => {
    setUserMenuOpen(false);
    history.push("/configuracion#perfil");
  };

  const refreshAfterPascale = useCallback(() => {
    dispatch(importUpdateTransactions(true));
    dispatch(setUpdateDocuments({ value: true }));
    dispatch(importUpdateDashboardNeeded({ value: true }));
    dispatch(updateConcilieantionRatio());
  }, [dispatch]);

  const applyPascaleProgress = useCallback((progress) => {
    if (!progress || progress.source !== "pascale") return;
    setPascaleOverlay((prev) => {
      if (!prev) return prev;
      const next = {
        ...prev,
        stepId: progress.layerKey || prev.stepId,
        outcome: {
          ...(prev.outcome || {}),
          matched: progress.matched ?? prev.outcome?.matched,
          created: progress.created ?? prev.outcome?.created,
          message: progress.message || prev.outcome?.message,
          errors: progress.errors,
        },
      };
      if (progress.step === "COMPLETED") {
        return { ...next, running: false, error: null };
      }
      if (progress.step === "ERROR") {
        return { ...next, running: false, error: progress.message || prev.error };
      }
      return { ...next, running: true, error: null };
    });
    if (progress.step === "COMPLETED" || progress.step === "ERROR") {
      refreshAfterPascale();
    }
  }, [refreshAfterPascale]);

  const handleRunAutomations = async (event) => {
    event?.stopPropagation?.();
    const activeCompanyId = selectedCompany?.id || selectedCompany?._id;

    if (!activeCompanyId) {
      dispatch(
        importAlertState({
          content: t("alerts.selectCompany"),
          state: "error",
          duration: 4,
        })
      );
      return;
    }

    if (
      pascaleOverlay?.running ||
      runAutomationsLoading ||
      isRunAutomationsLockActive(activeCompanyId)
    ) {
      if (pascaleOverlay) {
        setPascaleOverlay((prev) => ({ ...prev, collapsed: false }));
      }
      return;
    }

    if (!isInternalStaffForPascale || !canRunPascaleAccounting) {
      dispatch(
        importAlertState({
          content: t("alerts.noAutomations"),
          state: "warning",
          duration: 4,
        })
      );
      return;
    }

    setUserMenuOpen(false);
    const triggerEl = event?.currentTarget;
    const avatarEl = document.querySelector(".header-dropdown-avatar");
    const anchorRect = (avatarEl || triggerEl)?.getBoundingClientRect?.();
    const overlayCompanyId = String(activeCompanyId);
    const overlayCompanyName = selectedCompany?.name || t("workspace.defaultName");
    const canRunPascaleConciliation = hasRouteAccess("/conciliacion");
    setRunAutomationsLock(activeCompanyId);
    setRunAutomationsLoading(true);
    scheduleRunAutomationsRelease(activeCompanyId, RUN_AUTOMATIONS_LOCK_MS);
    setPascaleOverlay({
      running: true,
      collapsed: false,
      outcome: null,
      error: null,
      stepId: "connect",
      companyId: overlayCompanyId,
      companyName: overlayCompanyName,
      variant: canRunPascaleConciliation ? "full" : "accounting",
      anchorRect: anchorRect
        ? { top: anchorRect.top, bottom: anchorRect.bottom, left: anchorRect.left, right: anchorRect.right }
        : { top: 48, bottom: 56, left: window.innerWidth - 80, right: window.innerWidth - 16 },
    });

    const finishOverlay = (patch) => {
      setPascaleOverlay((prev) => {
        if (!prev || String(prev.companyId) !== overlayCompanyId) return prev;
        return { ...prev, ...patch };
      });
    };

    try {
      const [pascaleResult, layersResult] = await Promise.all([
        triggerPascaleBot({
          input: { companyIds: [activeCompanyId] },
        }),
        canRunPascaleConciliation
          ? executePascaleAutomations({
              input: { companyId: activeCompanyId },
            })
          : Promise.resolve({ data: { executePascaleAutomations: { success: true } } }),
      ]);

      const pascaleData = pascaleResult?.data?.triggerPascaleBot || {};
      const layersData = layersResult?.data?.executePascaleAutomations || {};
      const conciliationSkipped =
        !canRunPascaleConciliation ||
        (layersData?.success === false &&
          /módulo de conciliación no está activo/i.test(layersData?.message || ""));

      if (pascaleResult?.error && (layersResult?.error || conciliationSkipped)) {
        finishOverlay({
          running: false,
          error:
            layersResult?.error?.message ||
            pascaleResult.error.message ||
            t("alerts.accountingError"),
        });
        refreshAfterPascale();
        return;
      }

      const enqueueFailed = layersResult?.error && !layersData?.success;
      if (!conciliationSkipped && (enqueueFailed || layersData?.success === false)) {
        finishOverlay({
          running: false,
          error: layersResult?.error?.message || layersData?.message || t("alerts.accountingError"),
        });
        refreshAfterPascale();
        return;
      }

      finishOverlay({
        error: null,
        running: conciliationSkipped ? false : true,
        stepId: "accountingScan",
        variant: conciliationSkipped ? "accounting" : "full",
        outcome: {
          ...pascaleData,
          processedBatches: pascaleData.processedBatches,
        },
      });
      if (conciliationSkipped) {
        refreshAfterPascale();
      }
    } catch (e) {
      finishOverlay({
        running: false,
        error: e?.message || t("alerts.accountingError"),
      });
      refreshAfterPascale();
    } finally {
      releaseRunAutomationsLock();
    }
  };

  const displayName = useMemo(() => {
    if (isPlaceholderProfileName(name)) return "";
    return String(name).trim();
  }, [name]);
  const showProfileName = displayName.length > 0;
  const workspaceName = selectedCompany?.name || t("workspace.defaultName");

  const fullRoute = useMemo(() => {
    if (!location) return "/";
    return `${location.pathname || ""}${location.search || ""}${location.hash || ""}`;
  }, [location]);

  const {
    data: favoriteRoutesData,
    fetching: favoriteRoutesFetching,
    executeQuery: refetchFavoriteRoutes,
  } = GetMyFavoriteRoutes({ pause: !uid });

  const {
    profileAvatarUrl,
    refetchProfileAvatarUrl,
    onUploadSuccess: handleProfileUploadSuccess,
  } = useProfileAvatar({ pause: !uid });

  const { executeMutation: addFavoriteRouteMutation } = AddFavoriteRoute();
  const { executeMutation: removeFavoriteRouteMutation } = RemoveFavoriteRoute();

  const favoriteRoutes = favoriteRoutesData?.getMyFavoriteRoutes || [];

  useEffect(() => {
    if (!uid) return;
    refetchFavoriteRoutes({ requestPolicy: "cache-and-network" });
  }, [uid, refetchFavoriteRoutes]);

  const handleOpenFavoriteRouteModal = (event) => {
    event?.stopPropagation?.();
    setFavoriteRouteModalOpen(true);
  };

  const handleMenuAvatarClick = (event) => {
    event?.stopPropagation?.();
    setProfileUploadOpen(true);
  };

  const handleSaveFavoriteRoute = async (label) => {
    if (!label?.trim()) return;
    setSavingFavoriteRoute(true);
    try {
      const result = await addFavoriteRouteMutation({
        label: label.trim(),
        route: fullRoute,
        companyId: companyId || undefined,
      });
      if (result.error) {
        dispatch(
          importAlertState({
            concept: t("favorites.concept"),
            content: result.error.message || t("favorites.saveError"),
            state: "error",
            duration: 6,
          })
        );
        return;
      }
      setFavoriteRouteModalOpen(false);
      refetchFavoriteRoutes({ requestPolicy: "network-only" });
      dispatch(
        importAlertState({
          concept: t("favorites.concept"),
          content: t("favorites.saved"),
          state: "success",
          duration: 4,
        })
      );
    } finally {
      setSavingFavoriteRoute(false);
    }
  };

  const handleNavigateFavoriteRoute = (route, event) => {
    event?.stopPropagation?.();
    if (!route) return;
    history.push(route);
  };

  const handleRemoveFavoriteRoute = async (favorite, event) => {
    event?.stopPropagation?.();
    const favoriteRouteId = favorite?.id;
    if (!favoriteRouteId) return;

    const confirmed = window.confirm(
      t("favorites.confirmDelete", { label: favorite.label })
    );
    if (!confirmed) return;

    setRemovingFavoriteRouteId(favoriteRouteId);
    try {
      const result = await removeFavoriteRouteMutation({ favoriteRouteId });
      if (result.error) {
        dispatch(
          importAlertState({
            concept: t("favorites.concept"),
            content: result.error.message || t("favorites.deleteError"),
            state: "error",
            duration: 6,
          })
        );
        return;
      }
      refetchFavoriteRoutes({ requestPolicy: "network-only" });
      dispatch(
        importAlertState({
          concept: t("favorites.concept"),
          content: t("favorites.deleted"),
          state: "success",
          duration: 4,
        })
      );
    } finally {
      setRemovingFavoriteRouteId(null);
    }
  };

  const {
    executeMutation: paymentSuccessful,
    fetching: paymentSuccessfulLoading,
  } = PaymentSuccessful();
  const { data, fetching, reexecuteQuery } = GetPasswordsByCompany(companyId);
  const { executeMutation: markNotificationAsReadMutation } = MarkNotificationAsReaded();
  const { executeMutation: markAllNotificationAsReadMutation, fetching: markAllNotificationAsReadFetching } = MarkAllNotificationAsRead();

  const navigateFromNotification = useCallback(
    ({ redirectUrl, notificationCompany, notificationId }) => {
      setOpen(false);

      const targetUrl = redirectUrl
        ? normalizeNotificationRedirectUrl(redirectUrl)
        : null;
      dispatch(importOpenSidebar(openSidebarStateFromRedirectUrl(targetUrl)));

      if (notificationId && notificationsUserId) {
        markNotificationAsReadMutation({
          notificationId,
          userId: notificationsUserId,
          companyId: notificationCompany?.id || null,
        });
      }

      const targetCompanyId = notificationCompany?.id
        ? String(notificationCompany.id)
        : null;
      const activeCompanyId = String(selectedCompany?.id || companyId || "");

      if (targetCompanyId && activeCompanyId !== targetCompanyId) {
        pendingNotificationRedirectRef.current = {
          companyId: targetCompanyId,
          url: targetUrl,
        };
        const companyFromList = companyList?.find(
          (c) => String(c?.id) === targetCompanyId
        );
        dispatch(
          importSelectedCompany(companyFromList || notificationCompany, {
            userInitiated: true,
          })
        );
        return;
      }

      if (targetUrl) {
        if (hasAccountingAccess && isAccountSuggestionsRedirectUrl(targetUrl)) {
          const hashPart = targetUrl.includes('#') ? targetUrl.slice(targetUrl.indexOf('#') + 1) : '';
          openAccountSuggestionsPanel(parseSuggestionsDirectionFromUrl(hashPart));
          return;
        }
        history.push(targetUrl);
      }
    },
    [
      companyId,
      companyList,
      dispatch,
      history,
      markNotificationAsReadMutation,
      notificationsUserId,
      selectedCompany?.id,
      hasAccountingAccess,
      openAccountSuggestionsPanel,
    ]
  );

  useEffect(() => {
    const pending = pendingNotificationRedirectRef.current;
    if (!pending?.url) return;
    if (String(selectedCompany?.id || "") !== String(pending.companyId)) return;
    pendingNotificationRedirectRef.current = null;
    if (hasAccountingAccess && isAccountSuggestionsRedirectUrl(pending.url)) {
      const hashPart = pending.url.includes('#') ? pending.url.slice(pending.url.indexOf('#') + 1) : '';
      openAccountSuggestionsPanel(parseSuggestionsDirectionFromUrl(hashPart));
      return;
    }
    dispatch(importOpenSidebar(openSidebarStateFromRedirectUrl(pending.url)));
    history.push(pending.url);
  }, [hasAccountingAccess, dispatch, history, openAccountSuggestionsPanel, selectedCompany?.id]);

  const debugNotifications = (() => {
    try {
      return localStorage.getItem('debugNotifications') === 'true';
    } catch (e) {
      return false;
    }
  })();

  let title = "";
  if (location) {
    if (location.pathname.includes("flujo")) title = t("pageTitles.cashflow");
    else if (location.pathname.includes("documentos_tributarios"))
      title = t("pageTitles.taxDocuments");
    else if (location.pathname.includes("creditos")) title = t("pageTitles.loans");
    else if (location.pathname.includes("proveedores"))
      title = t("pageTitles.providerPayments");
    else if (location.pathname.includes("agenda"))
      title = t("pageTitles.contacts");
    else if (location.pathname.includes("conexiones")) title = t("pageTitles.connections");
    else if (location.pathname.includes("usuarios")) title = t("pageTitles.users");
    else if (location.pathname.includes("reportes")) title = t("pageTitles.reports");
    else if (location.pathname.includes("reportes_dj")) title = t("pageTitles.reportsDj");
    else if (location.pathname.includes("conciliacion"))
      title = t("pageTitles.bankReconciliation");
  }

  useEffect(() => {
    if (!fetching) {
      dispatch(importDataConexiones(data?.allPasswordsByCompanyId));
    }
  }, [dispatch, data]);


  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open]);

  // Historial persistido: solo al abrir el drawer (GET_APP_NOTIFICATIONS_LIST con pause hasta open=true).
  useEffect(() => {
    if (!open) return;
    if (debugNotifications && appNotificationsError) {
      console.warn('[Notifications][drawer] error', appNotificationsError);
    }
    if (appNotificationsFetching) {
      if (debugNotifications) {
        console.log('[Notifications][drawer] fetching...', { notificationsUserId });
      }
      return;
    }

    const list = appNotificationsData?.appNotifications;
    if (!Array.isArray(list)) return;

    if (debugNotifications) {
      console.log('[Notifications][drawer] received', { count: list.length });
    }

    applyLiveNotifications(list);
  }, [
    open,
    appNotificationsData,
    appNotificationsFetching,
    appNotificationsError,
    notificationsUserId,
    debugNotifications,
    applyLiveNotifications,
  ]);

  // WebSocket: badge y lista en vivo sin polling; el query pesado solo al abrir la campana.
  useEffect(() => {
    if (notificationsSubscriptionPaused) return;

    if (resNotifications?.error) {
      console.warn('[Notifications][subscription] error', resNotifications.error);
    }

    const list = resNotifications?.data?.notificationsReceived;
    if (!Array.isArray(list)) {
      if (debugNotifications) {
        console.log('[Notifications][subscription] payload (non-array)', resNotifications?.data);
      }
      return;
    }

    if (debugNotifications || process.env.NODE_ENV === "development") {
      console.log("[Notifications][subscription] received", {
        count: list.length,
        notificationsUserId,
      });
    }

    applyLiveNotifications(list);
  }, [
    resNotifications,
    notificationsSubscriptionPaused,
    applyLiveNotifications,
    debugNotifications,
    notificationsUserId,
  ]);

  useEffect(() => {
    reexecuteQuery({ requestPolicy: "network-only" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  useEffect(() => {
    dispatch(importMonedas());
  }, [dispatch]);
  const toggleSidebarMobile = () => {
    const val = [false, "responsive"].includes(sidebarShow)
      ? true
      : "responsive";
    dispatch(setSidebarResponsive(val));
  };

  useEffect(() => {
    if (openNotification) {
      setOpenNotification(false);
    }
  }, [location, openNotification]);

  useEffect(() => {
    if (!canUsePascaleChat) return undefined;

    let pulseTimeoutId = null;

    const triggerPulse = () => {
      setAiPulseActive(true);
      if (pulseTimeoutId) window.clearTimeout(pulseTimeoutId);
      pulseTimeoutId = window.setTimeout(() => setAiPulseActive(false), 1200);
    };

    const intervalId = window.setInterval(triggerPulse, 7000);
    triggerPulse();

    return () => {
      window.clearInterval(intervalId);
      if (pulseTimeoutId) window.clearTimeout(pulseTimeoutId);
    };
  }, [canUsePascaleChat]);

  useEffect(() => {
    moment.locale(getMomentLocale(i18n.language));
  }, [i18n.language]);

  useEffect(() => {
    if (!res.fetching && res.data) {
      const [botData] = res.data;
      const botName = botData?.botName;
      if (BELL_HIDDEN_BOTLOG_BOTNAMES.has(botName)) {
        return;
      }
      // Varios SubcribeWS / StrictMode: mismo botlog no debe crear varios toasts.
      if (!consumeBotlogToastOnce(botData)) {
        return;
      }
      const isUserEmailBotToast =
        botName === 'f29-email' || botName === 'cobranza-email';
      // Etapas de conciliación automática (cron/capas): sin toast. El panel de Pascale
      // solo se abre con «Ejecutar Pascale» manual.
      const suppressReconciliationToast = isReconciliationBotlog(botName);

      // Email manual (F29 / cobranza): un toast preciso; no sumar a la lista de notificaciones
      if (!isUserEmailBotToast) {
        dispatch(importNotifications(res.data));
      }

      if (botData) {
        if (
          isReconciliationBotlog(botName) &&
          botData.rawMssg &&
          botData.rawMssg !== botData.mssg
        ) {
          logReconciliationTechnicalError("BotlogWS", botData.rawMssg, { botName });
        }
        if (!suppressReconciliationToast) {
          dispatch(
            importAlertState({
              concept: botData.title,
              content: botData.mssg,
              state: botData.ok ? "success" : "error",
              duration: 8,
              toastKey: botData.id || undefined,
            })
          );
        }
        dispatch(setUpdateDocuments({ value: true }));
        dispatch(importUpdateProvidersData(true));
        dispatch(importUpdateCashFlow(true));
        dispatch(importUpdateTransactions(true));
        dispatch(importUpdateDashboardNeeded({ value: true }));
        dispatch(importUpdateBalanceNeeded({ value: true }));
        dispatch(importUpdatePasswordNeeded({ value: true }));
        dispatch(importUpdateNominaProccesedNeeded({ value: true }));
        dispatch(importUpdateNominaInProcessNeeded({ value: true }));
        dispatch(importUpdateProvidersData(true));
      }
    }
  }, [res.data, dispatch, res.fetching]);

  notification?.sort((a, b) => {
    if (a.ago > b.ago) {
      return -1;
    } else if (a.ago < b.ago) {
      return 1;
    } else {
      return 0;
    }
  });


  const clearUrlParams = () => {
    let type = searchParams.get("type");
    history.push(`?type=${type}&page=1&offset=20`);
  };

  const _pendingNotification =
    notification && notification?.some((value) => value?.visited === false);


  useEffect(() => {
    if (!notifications) return;

    let unreadedNotifications = 0;
    notifications.forEach((item) => {
      const recipients =
        item?.notification?.recipients || item?.recipients || [];
      const mine = recipients.find(
        (r) => String(r?.user) === String(notificationsUserId)
      );
      if (mine && mine.isRead === false) {
        unreadedNotifications += 1;
      }
    });

    setUnreadedNotificationsQuantity(unreadedNotifications);
  }, [notifications, notificationsUserId]);

  const _notPendingNotification = () => {
    const watchedNotification = notification?.map((value, index) => {
      return {
        title: value?.title,
        description: value?.description,
        ejecucionCorrecta: value?.ejecucionCorrecta,
        ago: value?.ago,
        visited: true,
        ok: value?.ok,
      };
    });
    dispatch(importUpdateNotifications(watchedNotification));
  };

  const DaysLeft = selectedCompany?.trialExpirationDate
    ? moment(selectedCompany?.trialExpirationDate).diff(moment(), "days", false)
    : 99;

  const _daysLeftMessage =
    selectedCompany &&
      selectedCompany.plan &&
      selectedCompany.plan.includes(Plans.blocked)
      ? ""
      : DaysLeft <= 30 && DaysLeft > 0
        ? DaysLeft === 1
          ? `¡Te queda ${DaysLeft} día de prueba!`
          : `¡Te quedan ${DaysLeft} días de prueba!`
        : "¡No te quedan días de prueba!";

  const isSCFOClient =
    selectedCompany &&
    selectedCompany.plan &&
    (selectedCompany.plan.includes(Plans.smartcfo) ||
      selectedCompany.plan.includes(Plans.smartcfopro) ||
      selectedCompany.plan.includes(Plans.smartcfofull));

  const canSeeConciliationHeader = hasRouteAccess("/conciliacion");

  const errorFounded =
    allConnections && Array.isArray(allConnections)
      ? allConnections.some((botLog) => {
        return (
          botLog?.isActive &&
          posiblePasswords[botLog.templateId] &&
          (botLog?.status === false ||
            ![
              "Ejecutado de forma correcta",
              "Ejecutado de forma correcta.",
              "Documentos actualizados correctamente",
              "Documentos actualizados correctamente.",
              "Documentos obtenidos exitosamente.",
              "Glosas obtenidas exitosamente.",
            ].includes(botLog?.botlogSummary[0]?.mssg))
        );
      })
      : false;
  const hasActiveConnections =
    allConnections && Array.isArray(allConnections)
      ? allConnections.some((conn) => conn?.isActive)
      : false;

  const _customer = {
    name: selectedCompany?.name || "",
    tax_id: rutWithDash(selectedCompany?.rut || ""),
    email: email || "",
  };

  const _metadata = {
    userID: uid || "",
    date: moment().toString(),
    companyId: selectedCompany?.id || "",
  };

  const getNotificationIsRead = (notification) => {
    if (!notification) return;

    const recipients = notification?.recipients || [];

    const curretRecipient = recipients.find(
      (recipient) => String(recipient?.user) === String(notificationsUserId)
    );

    if (!curretRecipient) return false;

    return curretRecipient?.isRead;
  };

  const markRecipientsAsReadInList = (list) =>
    (list || []).map((recipient) =>
      String(recipient?.user) === String(notificationsUserId)
        ? { ...recipient, isRead: true }
        : recipient
    );

  const markAllNotificationsAsRead = async () => {
    if (!notifications || notifications.length === 0) return;

    const hasUnread = notifications.some((item) => {
      const recipients =
        item?.notification?.recipients || item?.recipients || [];
      return recipients.some(
        (recipient) =>
          recipient?.isRead === false &&
          String(recipient?.user) === String(notificationsUserId)
      );
    });

    if (!hasUnread) return;

    setNotifications((prev) =>
      (prev || []).map((item) => ({
        ...item,
        recipients: markRecipientsAsReadInList(getNotificationRecipients(item)),
        notification: item.notification
          ? {
              ...item.notification,
              recipients: markRecipientsAsReadInList(
                getNotificationRecipients(item)
              ),
            }
          : item.notification,
      }))
    );
    setUnreadedNotificationsQuantity(0);

    try {
      await markAllNotificationAsReadMutation();
      await appNotificationsReexecuteQuery({ requestPolicy: "network-only" });
    } catch (error) {
      await appNotificationsReexecuteQuery({ requestPolicy: "network-only" });
    }
  };

  const getFilteredNotifications = () => {
    if (!notifications || notifications.length === 0) return [];
    
    return notifications.filter((notification) => {
      const isRead = getNotificationIsRead(notification?.notification);
      return activeTab === 'new' ? !isRead : isRead;
    });
  };



  return (
    <CHeader withSubheader className="headerShadow" style={{ zIndex: "1020", display: "flex", alignItems: "center", marginLeft: isMobile ? "0px" : (isFixed ? "256px" : "0px") }}>
      {/* Left Section */}
      <div style={{ display: "flex", alignItems: "center", flex: "1" }}>
        <CToggler
          inHeader
          className="ml-md-3 d-lg-none"
          onClick={toggleSidebarMobile}
        />
        <CHeaderNav>
          <CHeaderNavItem className="px-3">
            <div
              className={`header-company-selectors${isViewingCombinedCompanyData ? " header-company-selectors--combined" : ""}`}
            >
              <CompanyListComponent
                clearUrlParams={clearUrlParams}
                enableGroupChecklist={shouldShowReportGroupSelector}
                groupChecklistOptions={reportGroupCompanyOptions}
                groupChecklistSelectedValues={
                  Array.isArray(reportGroupCompanyIds) && reportGroupCompanyIds.length > 0
                    ? reportGroupCompanyIds
                    : (selectedCompanyData?.id ? [selectedCompanyData.id] : [])
                }
                onGroupChecklistChange={handleReportGroupCompaniesChange}
                groupChecklistLockedValues={selectedCompanyData?.id ? [String(selectedCompanyData.id)] : []}
              />
              {isViewingCombinedCompanyData && (
                <div className="header-company-selectors__combined-badge">
                  <Popup
                    inverted
                    position="bottom center"
                    content={combinedDataTooltip}
                    trigger={
                      <div
                        className="combined-company-data-indicator"
                        aria-label={`Combinados: ${normalizedReportGroupCompanyIds.length} empresas`}
                      >
                        <span className="combined-company-data-indicator__label">
                          Combinados
                        </span>
                        <span className="combined-company-data-indicator__count">
                          {normalizedReportGroupCompanyIds.length}
                        </span>
                      </div>
                    }
                  />
                  <button
                    type="button"
                    className={`neto-holding-toggle${excludeIntercompanyReports ? " neto-holding-toggle--active" : ""}`}
                    onClick={() =>
                      dispatch(
                        importExcludeIntercompanyReports(!excludeIntercompanyReports)
                      )
                    }
                    aria-pressed={Boolean(excludeIntercompanyReports)}
                    aria-label="Facturación cruzada"
                  >
                    <span className="neto-holding-toggle__glyph" aria-hidden="true">
                      <svg
                        className="neto-holding-toggle__glyph-svg"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <defs>
                          <clipPath id="neto-holding-venn-a">
                            <circle cx="7.6" cy="11.6" r="6.1" />
                          </clipPath>
                          <clipPath id="neto-holding-venn-b">
                            <circle cx="12.4" cy="8.4" r="6.1" />
                          </clipPath>
                        </defs>
                        <circle
                          className="neto-holding-toggle__venn-fill"
                          cx="7.6"
                          cy="11.6"
                          r="6.1"
                        />
                        <circle
                          className="neto-holding-toggle__venn-fill"
                          cx="12.4"
                          cy="8.4"
                          r="6.1"
                        />
                        <circle
                          className="neto-holding-toggle__venn-intersection"
                          cx="12.4"
                          cy="8.4"
                          r="6.1"
                          clipPath="url(#neto-holding-venn-a)"
                        />
                        <circle
                          className="neto-holding-toggle__venn-stroke"
                          cx="7.6"
                          cy="11.6"
                          r="6.1"
                          fill="none"
                        />
                        <circle
                          className="neto-holding-toggle__venn-stroke"
                          cx="12.4"
                          cy="8.4"
                          r="6.1"
                          fill="none"
                        />
                        <circle
                          className="neto-holding-toggle__venn-stroke--erase"
                          cx="7.6"
                          cy="11.6"
                          r="6.1"
                          fill="none"
                          clipPath="url(#neto-holding-venn-b)"
                        />
                        <circle
                          className="neto-holding-toggle__venn-stroke--erase"
                          cx="12.4"
                          cy="8.4"
                          r="6.1"
                          fill="none"
                          clipPath="url(#neto-holding-venn-a)"
                        />
                        <circle
                          className="neto-holding-toggle__venn-stroke neto-holding-toggle__venn-stroke--dashed"
                          cx="7.6"
                          cy="11.6"
                          r="6.1"
                          fill="none"
                          clipPath="url(#neto-holding-venn-b)"
                        />
                        <circle
                          className="neto-holding-toggle__venn-stroke neto-holding-toggle__venn-stroke--dashed"
                          cx="12.4"
                          cy="8.4"
                          r="6.1"
                          fill="none"
                          clipPath="url(#neto-holding-venn-a)"
                        />
                      </svg>
                    </span>
                    <span
                      className={`neto-holding-toggle__switch${excludeIntercompanyReports ? " is-on" : ""}`}
                      aria-hidden="true"
                    >
                      <span className="neto-holding-toggle__knob" />
                    </span>
                    <span className="neto-holding-toggle__label">Facturación cruzada</span>
                    <Popup
                      inverted
                      hoverable
                      position="bottom left"
                      wide
                      className="neto-holding-popup"
                      on="hover"
                      trigger={
                        <span
                          className="neto-holding-toggle__info"
                          onClick={(event) => event.stopPropagation()}
                          aria-label="Información sobre facturación cruzada"
                        >
                          <Icon name="info circle" fitted />
                        </span>
                      }
                      content={
                        <div className="neto-holding-popup__body">
                          <p className="neto-holding-popup__title">
                            {excludeIntercompanyReports
                              ? "Activado: sin facturación cruzada"
                              : "Desactivado: suma bruta"}
                          </p>
                          <p className="neto-holding-popup__text">
                            <strong>Activado:</strong> se descuentan las facturas emitidas entre
                            empresas del mismo grupo, para ver el neto consolidado como una sola
                            entidad.
                          </p>
                          <p className="neto-holding-popup__text">
                            <strong>Desactivado:</strong> todas las empresas suman completo,
                            incluidas las operaciones entre ellas.
                          </p>
                        </div>
                      }
                    />
                  </button>
                </div>
              )}
            </div>
          </CHeaderNavItem>
        </CHeaderNav>
        <CHeaderNav className="d-md-down-none">
          <CHeaderNavItem className="px-3">
            <CHeaderNavLink
              to="/dashboard"
              style={{
                color: "white",
                fontFamily: "Helvetica",
                fontSize: "26pt",
                fontWeight: "bold",
              }}
            ></CHeaderNavLink>
          </CHeaderNavItem>
        </CHeaderNav>
      </div>

      {/* Center spacer: keeps left/right header columns balanced */}
      <div style={{ flex: "1" }} />

      {/* Right Section */}
      <div style={{ display: "flex", alignItems: "center", flex: "1", justifyContent: "flex-end" }}>
        {(selectedCompany?.plan &&

          (selectedCompany.plan || []).includes(Plans.trial) &&

          DaysLeft <= 30 &&

          !isSCFOClient) ||
          (selectedCompany &&
            selectedCompany.plan &&
            selectedCompany.plan.includes("blocked")) ? (
          <>
            {/* <CHeaderNav className="px-3">
              <span className="headerDaysLeft">{daysLeftMessage}</span>
            </CHeaderNav> */}
            {/* <CHeaderNav className="px-3">
              <SuscribeButton customer={customer} metadata={metadata} />
            </CHeaderNav> */}
          </>
        ) : (
          <CHeaderNav>
            <CHeaderNavItem className="px-3"></CHeaderNavItem>
          </CHeaderNav>
        )}

        {/* <CHeaderNav>
          <CHeaderNavItem>
            <GlobalSearch />
          </CHeaderNavItem>
        </CHeaderNav> */}
      {canUsePascaleChat && (
        <AiSideChat open={aiChatOpen} onClose={() => setAiChatOpen(false)} companyId={companyId} />
      )}
      {hasAccountingAccess && (
        <AccountSuggestionsSidePanel
          open={accountSuggestionsPanelOpen}
          onClose={() => setAccountSuggestionsPanelOpen(false)}
          companyId={companyId}
          initialDirection={accountSuggestionsPanelDirection}
        />
      )}

      <CHeaderNav className="">
        <CHeaderNavItem className="h-100 d-flex align-items-center headerActionsItem">
          <div className="headerButtonsRow">
        {canSeeConciliationHeader && <ConciliationRatioCircle />}
        <Dropdown
          selectOnBlur={false}
          className="noCaret"
          trigger={
            <button
              type="button"
              className="headerCreateButton"
            >
              <span className="headerCreateButton__icon">+</span>
              <span className="headerCreateButton__label">{t("create.label")}</span>
            </button>
          }
        >
          <Dropdown.Menu
            className="headerAnimatedDropdownMenu"
            style={{
              marginLeft: "-80px",
              width: "200px",
              marginTop: "16px",
            }}
          >
            <Dropdown.Item
              onClick={() => !isCrearObligacionBlocked && setOpenPlusModal(true)}
              disabled={isCrearObligacionBlocked}
              style={{
                padding: "12px 16px",
                opacity: isCrearObligacionBlocked ? 0.5 : 1,
                cursor: isCrearObligacionBlocked ? "not-allowed" : "pointer",
              }}
            >
              <Icon name="plus" style={{ marginRight: "8px" }} />
              {t("create.obligation")}
            </Dropdown.Item>
            {hasAccountingAccess && !isAsientoBlocked && puedeCrearAsiento && (
              <Dropdown.Item
                onClick={() => setOpenJournalEntryModal(true)}
                style={{ padding: "12px 16px" }}
              >
                <Icon name="book" style={{ marginRight: "8px" }} />
                {t("create.journalEntry")}
              </Dropdown.Item>
            )}
            <Dropdown.Item
              onClick={() => {
                if (history.location.pathname !== "/conexiones") {
                  history.push("/conexiones");
                }
                dispatch(importOpenSidebar({ show: false, createConection: true }));
              }}
              style={{ padding: "12px 16px" }}
            >
              <Icon name="linkify" style={{ marginRight: "8px" }} />
              {t("create.connection")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
            {/* Connections Dropdown */}
            <Dropdown
              selectOnBlur={false}
              className="noCaret"
              trigger={
                <button type="button" className="headerConnectionsButton">
                  <span className="headerConnectionsButton__icon">
                    <Icon name="usb" />
                  </span>
                  <span className="headerConnectionsButton__label">{t("connections.label")}</span>
                </button>
              }
            >
              <Dropdown.Menu
                className="headerAnimatedDropdownMenu"
                style={{
                  marginLeft: "-150px",
                  width: "200px",
                  marginTop: "16px",
                }}
              >
                {!hideConnectionStatusList &&
                  !fetching &&
                  allConnections &&
                  allConnections.length > 0 &&
                  allConnections.map((conexion, index) => {
                    const botLogStatus =
                      conexion?.botlogSummary?.length > 0
                        ? conexion?.botlogSummary[0]?.status
                        : false;

                    if (posiblePasswords[conexion.templateId])
                      return (
                        <React.Fragment key={conexion.id || index}>
                          {conexion?.isActive && (
                            <Dropdown.Item
                              style={{ width: "250px" }}
                              className="dont-drop-hover"
                            >
                              <img
                                alt={conexion?.templateId}
                                src={
                                  bankLogo(conexion?.templateId) ||
                                  platformLogo(conexion?.templateId)
                                }
                                style={{ height: "52px", width: "40px" }}
                              />
                              <span className="conn-name truncateText">
                                {conexion?.name}
                              </span>
                              <Popup
                                inverted
                                position="bottom center"
                                content={
                                  !botLogStatus
                                    ? t("connections.statusError")
                                    : t("connections.statusOk")
                                }
                                trigger={
                                  <Icon
                                    className="mr-3 ml-3 position-absolute right-0"
                                    style={{ cursor: "pointer" }}
                                    name="circle"
                                    color={
                                      !botLogStatus
                                        ? "red"
                                        : "green"
                                    }
                                    size="small"
                                  />
                                }
                              />
                            </Dropdown.Item>
                          )}
                        </React.Fragment>
                      );

                    return null;
                  })}

                {!hideConnectionStatusList && hasActiveConnections && <Dropdown.Divider />}
                <Dropdown.Item
                  href="/conexiones"
                  style={{ textDecoration: "none" }}
                >
                  {t("connections.review")} <Icon name="angle right" />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Button
              className="headerBellButton"
              onClick={() => setOpen(!open)}
            >
              {unreadedNotificationsQuantity > 0 && !open && (
                <Label
                  circular
                  color="red"
                  size="mini"
                  className="headerBellButton__badge"
                >
                  {unreadedNotificationsQuantity}
                </Label>
              )}
              <span
                className={
                  open
                    ? "headerBellButton__icon is-open"
                    : "headerBellButton__icon"
                }
              >
                <img src={bellIcon} alt={t("notifications.bellAlt")} />
              </span>
            </Button>
            {open &&
              createPortal(
                <>
                  <div
                    className="notification-drawer-backdrop"
                    aria-hidden="true"
                    onMouseDown={() => setOpen(false)}
                  />
                  <Segment
                    className="notificationDrawer notification-drawer-panel"
                    onMouseDown={(event) => event.stopPropagation()}
                  >
                 <div className="notification-drawer__header">
                   <h3 className="notification-drawer__title">{t("notifications.title")}</h3>
                   <div className="notification-drawer__headerActions">
                     {unreadedNotificationsQuantity > 0 && activeTab === "new" && (
                       <button
                         type="button"
                         className="notification-drawer__markAll"
                         disabled={markAllNotificationAsReadFetching}
                         onClick={() => markAllNotificationsAsRead()}
                       >
                         {t("notifications.markAllRead")}
                       </button>
                     )}
                     <button
                       type="button"
                       className="notification-drawer__close"
                       aria-label={t("notifications.closeAria")}
                       onClick={() => setOpen(false)}
                     >
                       ×
                     </button>
                   </div>
                 </div>
                 <div className="ui divider"></div>
                 
                 {/* Tabs */}
                 <div className="tw-mb-4">
                   <FilterTabs
                     tabs={[
                       {
                         value: 'new',
                         label: t('notifications.tabs.new'),
                         count: unreadedNotificationsQuantity > 0 ? unreadedNotificationsQuantity : undefined
                       },
                       {
                         value: 'read',
                         label: t('notifications.tabs.read'),
                       }
                     ]}
                     activeTab={activeTab}
                     onTabChange={setActiveTab}
                   />
                 </div>
                 {getFilteredNotifications().length > 0 ? (
                   getFilteredNotifications().map((value, index) => {
                     return (
                       <Notification
                         notificationId={value?.id}
                         key={index}
                         index={index}
                         title={value?.title}
                        titleVariant={value?.titleVariant}
                         senderLabel={value?.senderLabel}
                         companyLabel={value?.companyLabel}
                         contextLabel={value?.contextLabel}
                         description={value?.description}
                         referenceType={value?.referenceType}
                         comment={value?.comment}
                         redirectUrl={value?.redirectUrl}
                         ago={value?.ago}
                         ok={value?.ok}
                         data={value}
                         isRead={getNotificationIsRead(value?.notification)}
                         notification={value?.notification}
                         setOpen={setOpen}
                         uid={notificationsUserId}
                         company={value.company}
                         onNavigate={navigateFromNotification}
                       />
                     );
                   })
                 ) : (
                   <div className="mainNotificationContainer">
                     <span className="mainNotificationContainer__title">
                       {activeTab === 'new' ? t('notifications.emptyNew') : t('notifications.emptyRead')}
                     </span>
                   </div>
                 )}
                  </Segment>
                </>,
                document.body
              )}
            {/* AI assistant launcher (robot morado) — permiso vía blockedFeatures (admin) */}
            {canUsePascaleChat && (
              <button
                type="button"
                className={`aiHeaderButton aiHeaderButton--iconOnly ${aiPulseActive ? "is-loading" : ""}`}
                onClick={openAiChat}
                title={t("pascale.openAssistant")}
              >
                <span className={`aiHeaderButton__icon ${aiPulseActive ? "is-loading" : ""}`}>
                  <img src={aiIcon} alt="" aria-hidden />
                </span>
              </button>
            )}
            {hasAccountingAccess && (
              <AiOpportunitiesDropdown companyId={selectedCompany?.id} />
            )}
          </div>
          {/* <CHeaderNavLink to="/dashboard" style={{color:"white", fontFamily: "Helvetica", fontSize: "14pt", "fontWeight": "regular"}}>Dolar: $766,41 / $776,41</CHeaderNavLink> */}
        </CHeaderNavItem>
      </CHeaderNav>
      <CHeaderNav className="">
        <CHeaderNavItem className="px-3">
          <div className="header-100-percent headerUserMenuDropdown">
            <Dropdown
              open={userMenuOpen}
              selectOnBlur={false}
              closeOnBlur={false}
              className="header-dropdown-avatar header-100-percent"
              onOpen={() => {
                setUserMenuOpen(true);
                if (uid) {
                  refetchFavoriteRoutes({ requestPolicy: "cache-and-network" });
                  refetchProfileAvatarUrl({ requestPolicy: "network-only" });
                }
              }}
              onClose={() => {
                languageSubmenuOpenRef.current = false;
                setUserMenuOpen(false);
              }}
              trigger={
                <div className="d-flex align-items-center header-100-percent">
                  {showProfileName && (
                    <span className="mr-2 header-100-percent d-flex align-items-center">
                      {displayName}
                    </span>
                  )}
                  <div className="header-100-percent d-flex align-items-center headerTriggerAvatarWrap">
                    {profileAvatarUrl ? (
                      <img
                        src={profileAvatarUrl}
                        alt=""
                        className="custom-avatar-header headerTriggerAvatar"
                      />
                    ) : (
                      <Image
                        src={UserIcon}
                        avatar
                        className="custom-avatar-header"
                      />
                    )}
                  </div>
                </div>
              }
            >
              <Dropdown.Menu className="headerUserMenu headerAnimatedDropdownMenu">
                <div className="headerUserMenu__inner">
                  <div className="headerUserMenu__arrow" aria-hidden="true" />

                  <div className="headerUserMenu__header">
                    <div className="headerUserMenu__userRow">
                      {canUploadProfileImage ? (
                        <button
                          type="button"
                          className="headerUserMenu__avatar headerUserMenu__avatar--clickable"
                          onClick={handleMenuAvatarClick}
                          aria-label={t("userMenu.changePhotoAria")}
                        >
                          {profileAvatarUrl ? (
                            <img
                              src={profileAvatarUrl}
                              alt=""
                              className="headerUserMenu__avatarImg"
                            />
                          ) : (
                            <Icon name="user" />
                          )}
                        </button>
                      ) : (
                        <div className="headerUserMenu__avatar" aria-hidden={false}>
                          {profileAvatarUrl ? (
                            <img
                              src={profileAvatarUrl}
                              alt=""
                              className="headerUserMenu__avatarImg"
                            />
                          ) : (
                            <Icon name="user" />
                          )}
                        </div>
                      )}

                      <div className="headerUserMenu__info">
                        {showProfileName && (
                          <div className="headerUserMenu__nameRow">
                            <h3>{displayName}</h3>
                            <span
                              className="headerUserMenu__status headerUserMenu__status--hidden"
                              aria-hidden="true"
                            >
                              <Icon name="check circle" />
                              {t("userMenu.statusActive")}
                            </span>
                          </div>
                        )}
                        <p>{email}</p>
                      </div>

                      <HeaderLanguageSelector
                        placement="menu"
                        userMenuOpen={userMenuOpen}
                        onSubmenuOpenChange={handleLanguageSubmenuOpenChange}
                      />
                    </div>

                    <div
                      className="headerUserMenu__workspace headerUserMenu__workspace--hidden"
                      aria-hidden="true"
                    >
                      <div className="headerUserMenu__workspaceIcon">
                        <Icon name="building" />
                      </div>
                      <div className="headerUserMenu__workspaceText">
                        <span>{t("userMenu.currentWorkspace")}</span>
                        <strong>{workspaceName}</strong>
                      </div>
                      <Icon name="chevron right" className="headerUserMenu__chevron" />
                    </div>

                    <div className="headerUserMenu__favoritesSection">
                      <button
                        type="button"
                        className="headerUserMenu__action"
                        onClick={handleOpenFavoriteRouteModal}
                      >
                        <div className="headerUserMenu__actionIcon">
                          <Icon name="star" />
                        </div>
                        <div>
                          <strong>{t("userMenu.addFavorite")}</strong>
                          <span>{t("userMenu.saveCurrentPage")}</span>
                        </div>
                      </button>

                      <div className="headerUserMenu__favorites">
                        {favoriteRoutesFetching && favoriteRoutes.length === 0 ? (
                          <p className="headerUserMenu__favoritesEmpty">{t("userMenu.favoritesLoading")}</p>
                        ) : favoriteRoutes.length === 0 ? (
                          <p className="headerUserMenu__favoritesEmpty">{t("userMenu.favoritesEmpty")}</p>
                        ) : (
                          favoriteRoutes.map((favorite) => (
                            <div key={favorite.id} className="headerUserMenu__favoriteItem">
                              <span
                                className="headerUserMenu__favoriteLinkWrap"
                                title={
                                  favorite.label.length > FAVORITE_ROUTE_LABEL_DISPLAY_MAX
                                    ? `${favorite.label}\n${favorite.route}`
                                    : favorite.route
                                }
                              >
                                <button
                                  type="button"
                                  className="headerUserMenu__favoriteLink"
                                  onClick={(event) =>
                                    handleNavigateFavoriteRoute(favorite.route, event)
                                  }
                                >
                                  {truncateFavoriteRouteLabel(favorite.label)}
                                </button>
                                <span className="headerUserMenu__favoriteHoverHint" aria-hidden="true">
                                  <i className="arrow up right icon headerUserMenu__favoriteHoverIcon" />
                                </span>
                              </span>
                              <button
                                type="button"
                                className="headerUserMenu__favoriteDelete"
                                onClick={(event) =>
                                  handleRemoveFavoriteRoute(favorite, event)
                                }
                                disabled={removingFavoriteRouteId === favorite.id}
                                aria-label={t("userMenu.deleteFavoriteAria", { label: favorite.label })}
                              >
                                <Icon name="trash" />
                              </button>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="headerUserMenu__actions">
                    {isInternalStaffForPascale && (
                      <button
                        type="button"
                        className={`headerUserMenu__action headerUserMenu__action--automations${
                          runAutomationsLoading ? " is-loading" : ""
                        }`}
                        onClick={runAutomationsLoading ? undefined : handleRunAutomations}
                        aria-disabled={runAutomationsLoading}
                        aria-busy={runAutomationsLoading}
                        tabIndex={runAutomationsLoading ? -1 : 0}
                      >
                        <span
                          className="headerUserMenu__menuIconWrap headerUserMenu__menuIconWrap--automations"
                          aria-hidden="true"
                        >
                          <span
                            className={`aiHeaderButton__icon${
                              runAutomationsLoading ? " is-loading" : ""
                            }`}
                          >
                            <img src={aiIcon} alt="" />
                          </span>
                        </span>
                        <div className="headerUserMenu__automationsText">
                          <strong>{t("pascale.run")}</strong>
                          <span>
                            {runAutomationsLoading
                              ? t("pascale.running")
                              : t("pascale.runAutomations")}
                          </span>
                        </div>
                      </button>
                    )}

                    <button
                      type="button"
                      className="headerUserMenu__action"
                      onClick={handleGoToProfile}
                    >
                      <span
                        className="headerUserMenu__menuIconWrap headerUserMenu__menuIconWrap--profile"
                        aria-hidden="true"
                      >
                        <img src={UserIcon} alt="" />
                      </span>
                      <div>
                        <strong>{t("userMenu.profile")}</strong>
                        <span>{t("userMenu.profileHint")}</span>
                      </div>
                      <Icon name="chevron right" className="headerUserMenu__chevron" />
                    </button>

                    <button
                      type="button"
                      className="headerUserMenu__action headerUserMenu__action--logout"
                      onClick={handleLogout}
                    >
                      <span
                        className="headerUserMenu__menuIconWrap headerUserMenu__menuIconWrap--logout"
                        aria-hidden="true"
                      >
                        <img src={logOutWhiteIcon} alt="" />
                      </span>
                      <div>
                        <strong>{t("userMenu.logout")}</strong>
                        <span>{t("userMenu.logoutHint")}</span>
                      </div>
                    </button>
                  </div>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </CHeaderNavItem>
      </CHeaderNav>
      </div>
      
      <FavoriteRouteModal
        open={favoriteRouteModalOpen}
        onClose={() => setFavoriteRouteModalOpen(false)}
        onSave={handleSaveFavoriteRoute}
        saving={savingFavoriteRoute}
      />

      {canUploadProfileImage && (
        <ProfileImageUploadModal
          open={profileUploadOpen}
          onClose={() => setProfileUploadOpen(false)}
          onSuccess={handleProfileUploadSuccess}
        />
      )}

      {/* Create Obligation Modal */}
      <CreateObligationModal
        open={openPlusModal && !isCrearObligacionBlocked}
        onClose={() => setOpenPlusModal(false)}
      />
      
      {/* Create Journal Entry Modal */}
      <CreateJournalEntryModal
        open={openJournalEntryModal}
        onClose={() => setOpenJournalEntryModal(false)}
        editData={null} // Free entry - no editData
      />

      {pascaleOverlay ? (
        <>
          <PascaleProgressListener
            companyId={pascaleOverlay.companyId}
            onProgress={applyPascaleProgress}
          />
          <PascaleRunProgress
            companyName={pascaleOverlay.companyName || workspaceName}
            running={pascaleOverlay.running}
            outcome={pascaleOverlay.outcome}
            error={pascaleOverlay.error}
            collapsed={pascaleOverlay.collapsed}
            anchorRect={pascaleOverlay.anchorRect}
            variant={pascaleOverlay.variant || "full"}
            stepId={pascaleOverlay.stepId}
            onCollapse={() => setPascaleOverlay((prev) => ({ ...prev, collapsed: true }))}
            onExpand={() => setPascaleOverlay((prev) => ({ ...prev, collapsed: false }))}
            onClose={() => setPascaleOverlay(null)}
          />
        </>
      ) : null}
    </CHeader>
  );
};

const Notification = ({
  notificationId,
  title,
  titleVariant,
  senderLabel,
  companyLabel,
  contextLabel,
  index,
  description,
  comment,
  redirectUrl,
  referenceType,
  ago,
  ok,
  data,
  setOpen,
  isRead,
  company,
  onNavigate,
}) => {
  const { t, i18n } = useTranslation("header");

  useEffect(() => {
    moment.locale(getMomentLocale(i18n.language));
  }, [i18n.language]);

  const renderCommentWithHighlight = (text) => {
    if (!text) return null;
    return parseCommentMentionParts(text).map((part, idx) =>
      part.type === "mention" ? (
        <span key={idx} className="notification-email">
          {part.value}
        </span>
      ) : (
        <span key={idx}>{part.value}</span>
      )
    );
  };

  const renderNotificationTitle = () => {
    if (senderLabel) {
      const suffix =
        titleVariant === "assignment"
          ? " te asignó una tarea"
          : " te ha mencionado en un comentario";
      return (
        <>
          <span className="notification-drawer__sender">{senderLabel}</span>
          <span className="notification-drawer__titleSuffix">
            {" "}
            {t("notifications.mentionSuffix")}
          </span>
        </>
      );
    }
    return title;
  };

  const resolvedCompanyLabel =
    companyLabel || company?.alias || company?.name || null;
  const isMentionLayout = Boolean(senderLabel && resolvedCompanyLabel);

  const goToComment = () => {
    onNavigate?.({
      redirectUrl,
      notificationCompany: company,
      notificationId,
    });
  };

  return (
    <div
      className={`mainNotificationContainer ${redirectUrl ? 'tw-cursor-pointer' : ''}`}
      key={index}
      onClick={() => goToComment()}
    >
      <div className="mainNotificationContainer__notification">
        {isMentionLayout ? (
          <>
            <div className="notification-drawer__companyHeader">
              <span className="notification-drawer__companyName">
                {resolvedCompanyLabel}
              </span>
              {!isRead && (
                <span
                  className="notification-drawer__unreadDot"
                  aria-hidden="true"
                />
              )}
            </div>
            {contextLabel && (
              <span className="notification-drawer__contextLabel">
                {contextLabel}
              </span>
            )}
            <div className="notification-drawer__mentionCard">
              <div className="notification-drawer__mentionCardHeader">
                {renderNotificationTitle()}
              </div>
              {comment && (
                <div className="notification-drawer__commentBox notification-drawer__commentBox--nested">
                  {renderCommentWithHighlight(comment)}
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <span className="mainNotificationContainer__notification__title notification-drawer__titleLine">
              <div className="notification-drawer__titleText">
                {renderNotificationTitle()}
              </div>
              {!isRead && (
                <span
                  className="notification-drawer__unreadDot"
                  aria-hidden="true"
                />
              )}
            </span>
            {description && (
              <span className="mainNotificationContainer__notification__description">
                {description}
              </span>
            )}
            {comment && (
              <div className="notification-drawer__commentBox">
                {renderCommentWithHighlight(comment)}
              </div>
            )}
          </>
        )}
        <span className="mainNotificationContainer__notification__ago">
          {moment(ago, "DD-MM-YYYY h:mm:ss").diff(moment(), "days") > 1
            ? moment(ago, "DD-MM-YYYY h:mm:ss").format("DD-MM-YYYY h:mm:ss")
            : moment(ago, "DD-MM-YYYY h:mm:ss").fromNow()}
        </span>
      </div>
      {/* <div className="mainNotificationContainer__trashContainer">
        <img
          src={iconTrash}
          alt="trash"
          className="mainNotificationContainer__trashContainer__icon tw-cursor-pointer"
        />
      </div> */}
    </div>
  );
}

export default Header;
